import {
	IFormFieldConfig,
	IFormOperation,
	IFormStepConfig,
	IOperation,
	OPERATION_TYPE,
} from '../models/user-identification';

export function getFormSteps(config: IFormOperation['config'] | null | undefined): IFormStepConfig[] {
	if (!config?.steps?.length) {
		return [];
	}

	return [...config.steps].sort((a, b) => a.order - b.order);
}

/** True si algún campo FORM trae valor de prefill OCR. */
export function formConfigHasPrefill(config: IFormOperation['config'] | null | undefined): boolean {
	return !!config?.steps?.some((step) =>
		step.fields?.some((field: IFormFieldConfig) => {
			const value = field.default_value;
			return value !== undefined && value !== null && value !== '';
		}),
	);
}

/**
 * NIF-658: fusiona `FORM.config` del process del back (prefill/disabled) sin reemplazar el resto de ops.
 * Devuelve el mismo array si no hay FORM con prefill o no hay FORM local.
 */
export function mergeFormConfigFromProcess(
	localOperations: IOperation[],
	process: IOperation[],
): IOperation[] {
	const freshForm = process.find((op) => op.type === OPERATION_TYPE.FORM) as IFormOperation | undefined;
	if (!formConfigHasPrefill(freshForm?.config)) {
		return localOperations;
	}

	const localIdx = localOperations.findIndex((op) => op.type === OPERATION_TYPE.FORM);
	if (localIdx < 0) {
		return localOperations;
	}

	const localForm = localOperations[localIdx] as IFormOperation;
	return localOperations.map((op, index) =>
		index === localIdx ? ({ ...localForm, config: { ...freshForm!.config } } as IFormOperation) : op,
	);
}
